import type {InviteApiModel} from '../../../../api/invite';

import {inviteStore} from '../../../../api/invite';
import {DeleteInviteStrategy} from './DeleteInviteStrategy';

export class DeleteRegularInviteStrategy extends DeleteInviteStrategy {
  constructor(private invite: InviteApiModel) {
    super();
  }

  async deleteInvite() {
    await inviteStore.delete(this.invite);
  }
}
